module.exports = __webpack_public_path__ + "img/pluto54.46f68af4.jpg";